import { toast } from "sonner";
import { joinFieldNames } from "./stageRequirements";

const REFUSED_MOVE_TOAST_DURATION_MS = 9000;

/** What the board knows about a stage move the server refused. */
export interface RefusedStageMove {
  stageName: string | undefined;
  error: string | null;
  missingFields: string[];
  onFillInFields: () => void;
}

/**
 * Explains a refused stage move. When the stage is waiting on fields, names
 * them and offers a "Fill in fields" action; otherwise shows the server's error.
 * @param move - The refused move
 * @returns Nothing
 */
export function showRefusedStageMove({
  stageName,
  error,
  missingFields,
  onFillInFields,
}: RefusedStageMove): void {
  if (!stageName || missingFields.length === 0) {
    toast.error(error ?? "Failed to update opportunity stage");
    return;
  }
  toast.error(`Can't move to ${stageName} yet`, {
    description: `Fill in ${joinFieldNames(missingFields)} first.`,
    duration: REFUSED_MOVE_TOAST_DURATION_MS,
    action: { label: "Fill in fields", onClick: onFillInFields },
  });
}
